import { render, staticRenderFns } from "./ResourceCreateSubmit.vue?vue&type=template&id=72c9985f&"
import script from "./ResourceCreateSubmit.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c9985f')) {
      api.createRecord('72c9985f', component.options)
    } else {
      api.reload('72c9985f', component.options)
    }
    module.hot.accept("./ResourceCreateSubmit.vue?vue&type=template&id=72c9985f&", function () {
      api.rerender('72c9985f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/steps/ResourceCreateSubmit.vue"
export default component.exports